import React from "react";

import { AutocompleteProps } from "@mui/material/Autocomplete";
import { Typography } from "components/ui/Typography";
import { ListItem } from "components/ui/list/List";
import { Tooltip } from "components/ui/tooltip";
import truncate from "lodash/truncate";

export const renderOptions = (props, option, state) => {
  const { label, value, isCustom } = option;
  return (
    <ListItem {...props}>
      <Tooltip
        placement="right"
        title={
          isCustom
            ? truncate(value, {
                length: 200,
                separator: /,? +/,
              })
            : ""
        }
      >
        <Typography
          variant="body2"
          sx={{
            color: isCustom ? "rgb(165, 47, 196)" : "inherit",
          }}
        >
          {label}
        </Typography>
      </Tooltip>
    </ListItem>
  );
};
